import PropTypes from "prop-types";
import React, { useState, useEffect, useMemo } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

// i18n
import menuItems from "../../../utils/menuItems";
import { useTranslation } from "react-i18next";
import classname from "classnames";
import { hasRight } from "../../../utils/userTools";
import { useSelector } from "react-redux";

export default function Navbar(props) {
  const { t } = useTranslation();
  const [menuState, setMenuState] = useState({});
  const user = useSelector((state) => state.Login.user);
  const location = useLocation();

  useEffect(() => {
    let matchingMenuItem = null;
    const ul = document.getElementById("navigation");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (const item of items) {
      if (window.location.pathname === item.pathname) {
        matchingMenuItem = item;
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = (items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      const parent = items[i].parentElement;
      if (item?.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  const toggleMenu = (menuKey) => {
    setMenuState((prevState) => ({
      ...prevState,
      [menuKey]: !prevState[menuKey],
    }));
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  // Filter menu items based on user rights
  const filteredMenuItems = useMemo(() => {
    // Filter top-level items
    return menuItems.filter(item => {
// Always show dashboard or check if user has read rights for this menu item
return hasRight(item.rightName, 'r', user)
    }

      
    ).map(item => {
      // If the item has subitems, filter those too
      if (item.subItems) {
        return {
          ...item,
          subItems: item.subItems.filter(subItem => 
            // Apply the same logic to subitems
            (subItem.rightName && hasRight(subItem.rightName, 'r'))
          )
        };
      }
      return item;
    });
  }, []);

  return (
    <div className="topnav">
      <div className="container-fluid">
        <nav
          className="navbar navbar-light navbar-expand-lg topnav-menu"
          id="navigation"
        >
          <Collapse
            isOpen={props.isNavbarOpen}
            className="navbar-collapse"
            id="topnav-menu-content"
          >
            <ul className="navbar-nav">
              {filteredMenuItems.map((menuItem) => (
                <li className="nav-item dropdown" key={menuItem.label}>
                  {menuItem.subItems && menuItem.subItems.length > 0 ? (
                    <Link
                      className="nav-link arrow"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu(menuItem.label);
                      }}
                      to={menuItem.link}
                    >
                      <i className={menuItem.icon}></i>
                      {t(menuItem.label)} {props.menuOpen}
                      <i className='bx bx-chevron-down arrowDown'></i>
                    </Link>
                  ) : (
                    <Link
                      className={`nav-link${location.pathname.startsWith(menuItem.link) ? " active" : ""}`}
                      to={menuItem.link}
                    >
                      <i className={menuItem.icon}></i>
                      {t(menuItem.label)} {props.menuOpen}
                    </Link>
                  )}
                  {menuItem.subItems && menuItem.subItems.length > 0 && (
                    <div
                      className={classname("dropdown-menu", {
                        show: menuState[menuItem.label],
                      })}
                    >
                      {menuItem.subItems.map((subItem) => (
                        <Link
                          to={subItem.link}
                          className="dropdown-item"
                          key={subItem.label}
                        >
                          {t(subItem.label)}
                        </Link>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </Collapse>
          <Link
            className="nav-link backToWebsite"
            to={'https://www.cenco.fr/'}
          >
            <p>CENCO.fr</p>
            <i className={'mdi mdi-arrow-right-circle-outline navIcon'}></i>
          </Link>
        </nav>
      </div>
    </div>
  );
};